<template>
    <div>
        <b-navbar class="px-0 justify-content-between">

            <b-navbar-brand><h4>Гипотетический типовой (эталонный) объект недвижимости</h4></b-navbar-brand>

            <b-button variant="outline-primary" v-on:click="reset_values" title="Сброс текущих значений" v-b-tooltip:fullscreen.hover.bottomright><base-icon name="delete" /></b-button>

        </b-navbar>

        <b-table :fields="fields" :items="showed_attrs">

            <template #cell(weighted_average)="cell_data">
                <template v-if="cell_data.item.reference">{{ format_reference(cell_data.item.reference, cell_data.value) }}</template>
                <template v-else-if="cell_data.item.type == 'number'">{{ round3(cell_data.value) }}</template>
                <template v-else>{{ cell_data.value }}</template>
            </template>

            <template #cell(current_value)="cell_data">

                <v-select v-if="cell_data.item.reference"
                    v-model="cell_data.value"
                    :options="get_reference_options(cell_data.item.reference)" label="label"
                    :reduce="(option) => option.code"
                    :clearable="true" @input="(value) => set_value(cell_data.item.id, value)"
                />

                <b-form-input v-else :type="cell_data.item.type == 'number' ? 'number' : 'text'" :value="cell_data.item.current_value"
                    @change="(evt) => set_value(cell_data.item.id, evt, cell_data.item.type)"
                />

            </template>

        </b-table>
    </div>
</template>

<script>
import api from "../../../../../../api";
import attrs from "../../../../../../api/attrs"

export default {
    props :
    {
        data : Array
    },

    data()
    {
        return {
            showed_attrs: null,
            attrs: null,
            fields :
            [
                { key : "name", label : "Наименование ЦОФ" },
                { key : "weighted_average", label : "Средневзвешенное значение" },
                { key : "current_value", label : "Значение пользователя" },
            ]
        }
    },

    watch :
    {
        data :
        {
            handler()
            {
                if (this.attrs == null)
                {
                    attrs.get(this).then((res) => {
                        this.attrs = res.attrs
                        this.update()
                    })
                }
                else
                {
                    this.update()
                }
            },
            immediate : true
        }
    },

    methods :
    {
        update()
        {
            this.showed_attrs = this.data.map((data_attr) => {
                const _attr = this.attrs.find((attr) => attr.id == data_attr.id)
                if (_attr)
                {
                    const attr = {
                        ..._attr,
                        ...data_attr
                    }

                    return attr
                }
                else
                {
                    return data_attr
                }
            })
        },

        format_reference(ref, value)
		{
            return api.format_reference(ref, value)
		},

        get_reference_options(ref)
        {
            return ref.values.map((code) => ({ label: this.format_reference(ref, code), code }))
        },

        round3(value)
        {
            return api.roundToStr(value, 3)
        },

        reset_values()
        {
            this.$emit("set_value", this.data.map((attr) => ({ ...attr, current_value: null })))
        },

        set_value(id, value, type)
        {
            const _value = value == null || value == "" 
                ? null
                : type == "number"
                    ? Number(value)
                    : value

            const _data = this.data.map((attr) => ({
                ...attr,
                current_value: attr.id == id ? _value : attr.current_value
            }))

            this.$emit("set_value", _data)
        },
    }
}
</script>
